(function () {
    'use strict';

    var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

    // Element for an in-page link ("#about"); null for full URLs (menu links on inner pages point to the home page)
    function target(href) {
        if (!href || href.charAt(0) !== '#' || href.length < 2) return null;
        try { return document.querySelector(href); } catch (e) { return null; }
    }

    /* ---------- Sticky header + back to top ---------- */
    var header = $('#siteHeader');
    var toTop = $('#toTop');

    function onScroll() {
        var y = window.pageYOffset;
        header.classList.toggle('is-sticky', y > 40);
        toTop.classList.toggle('is-visible', y > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    toTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    /* ---------- Mobile menu ---------- */
    var nav = $('#mainNav');
    var toggle = $('#navToggle');
    var overlay = $('#navOverlay');

    function setMenu(open) {
        nav.classList.toggle('is-open', open);
        overlay.classList.toggle('is-visible', open);
        document.body.classList.toggle('nav-open', open);
        toggle.setAttribute('aria-expanded', open);
    }

    toggle.addEventListener('click', function () { setMenu(true); });
    $('#navClose').addEventListener('click', function () { setMenu(false); });
    overlay.addEventListener('click', function () { setMenu(false); });

    /* ---------- Smooth scroll for in-page links (data-scroll) ---------- */
    function headerOffset() {
        return header.offsetHeight - 10;
    }

    $$('a[data-scroll]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var id = link.getAttribute('href');
            var el = target(id);
            if (!el) return;
            e.preventDefault();
            setMenu(false);
            var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
            window.scrollTo({ top: id === '#home' ? 0 : top, behavior: 'smooth' });
            if (history.replaceState) history.replaceState(null, '', id);
        });
    });

    /* ---------- Page opened with a hash (#contact-form after sending the form, /#about from an inner page) ---------- */
    var hashTarget = target(location.hash);
    if (hashTarget && location.hash !== '#home') {
        window.addEventListener('load', function () {
            var top = hashTarget.getBoundingClientRect().top + window.pageYOffset - headerOffset();
            window.scrollTo({ top: top, behavior: 'instant' });
        });
    }

    /* ---------- Scroll spy: highlight the menu item of the section in view ---------- */
    var navItems = $$('.main-nav > ul > li');
    var sections = navItems.map(function (li) {
        var a = $('a', li);
        return { li: li, el: a ? target(a.getAttribute('href')) : null };
    }).filter(function (s) { return s.el; });

    function spy() {
        if (!sections.length) return;
        var pos = window.pageYOffset + headerOffset() + Math.round(window.innerHeight * 0.35);
        var current = sections[0];
        sections.forEach(function (s) {
            if (s.el.offsetTop <= pos) current = s;
        });
        // bottom of the page: last section
        if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2) {
            current = sections[sections.length - 1];
        }
        navItems.forEach(function (li) { li.classList.toggle('is-active', current && li === current.li); });
    }
    window.addEventListener('scroll', spy, { passive: true });
    window.addEventListener('resize', spy);
    spy();

    /* ---------- Scroll reveal ---------- */
    var revealEls = $$('[data-reveal]');

    if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                io.unobserve(entry.target);
            });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

        revealEls.forEach(function (el) { io.observe(el); });
    } else {
        revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---------- Presentations slider (scroll-snap + prev / next) ---------- */
    var slider = $('#presSlider');
    var prevBtn = $('#presPrev');
    var nextBtn = $('#presNext');

    if (slider && prevBtn && nextBtn) {
        function step() {
            var card = $('.pres-card', slider);
            return card ? card.offsetWidth + 22 : slider.clientWidth;
        }
        function slide(dir) {
            var max = slider.scrollWidth - slider.clientWidth;
            var cur = slider.scrollLeft;
            var next;
            // one card per click, wrapping around at either end
            if (dir > 0) {
                next = cur >= max - 2 ? 0 : Math.min(cur + step(), max);
            } else {
                next = cur <= 2 ? max : Math.max(cur - step(), 0);
            }
            slider.scrollTo({ left: next, behavior: 'smooth' });
        }
        prevBtn.addEventListener('click', function () { slide(-1); });
        nextBtn.addEventListener('click', function () { slide(1); });
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setMenu(false);
    });

    /* ---------- Lightbox (home page gallery) ---------- */
    var lb = $('#lightbox');
    var items = $$('[data-lightbox]');
    var current = 0;
    if (!lb || !items.length) return;
    var lbImg = $('img', lb);
    var lbCap = $('figcaption', lb);

    function show(i) {
        current = (i + items.length) % items.length;
        lbImg.src = items[current].getAttribute('href');
        lbImg.alt = items[current].getAttribute('data-caption') || '';
        lbCap.textContent = items[current].getAttribute('data-caption') || '';
    }

    function closeLb() {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('nav-open');
    }

    items.forEach(function (a) {
        a.addEventListener('click', function (e) {
            e.preventDefault();
            show(items.indexOf(a));
            lb.classList.add('is-open');
            lb.setAttribute('aria-hidden', 'false');
            document.body.classList.add('nav-open');
        });
    });

    $('.lightbox__close', lb).addEventListener('click', closeLb);
    $('.lightbox__nav--prev', lb).addEventListener('click', function () { show(current - 1); });
    $('.lightbox__nav--next', lb).addEventListener('click', function () { show(current + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });

    document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
    });
})();
